"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _HeadingConstants = require("../text/HeadingConstants");

var _AbstractElement = _interopRequireDefault(require("../elements/AbstractElement"));

// 100% arbitrary cutoff for widthConstrained mode
var CONSTRAINED_TITLE_WIDTH = 544;

var renderTitle = function renderTitle(title, badge) {
  if (!badge) return title;
  var badgeOutput = (0, _react.cloneElement)(badge, {
    className: (0, _classnames.default)(badge.props.className, 'private-header__badge')
  });
  return _react.default.createElement("span", {
    className: "private-header__title__inner"
  }, title, badgeOutput);
};

var renderHeading = function renderHeading(badge, children, headingLevel, title, titleBadge, titleControls) {
  var headerContentNextToTitle = titleControls || titleBadge;
  var titleControlsWrapper = headerContentNextToTitle ? _react.default.createElement("div", {
    className: "private-header__title-badge"
  }, headerContentNextToTitle) : null;
  var titleWrapperClassName = (0, _classnames.default)('private-header__title', {
    'private-page__title': headingLevel === 'h1'
  });
  return _react.default.createElement("div", {
    className: titleWrapperClassName
  }, _react.default.createElement(_AbstractElement.default, {
    className: (0, _classnames.default)('private-header__heading', {
      'private-header__heading--solo': !children && !titleControls
    }),
    tagName: headingLevel
  }, renderTitle(title, badge)), titleControlsWrapper);
};

var renderToolbar = function renderToolbar(children) {
  return children ? _react.default.createElement("div", {
    className: "private-header__toolbar"
  }, children) : null;
};
/**
 * Standard page title which allows CTAs, filters, etc.
 */


var UIHeader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIHeader, _Component);

  function UIHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      widthConstrained: false
    };

    _this.handleWindowResize = function () {
      _this.testWidth();
    };

    _this.headerRefCallback = function (headerEl) {
      _this._headerEl = headerEl;

      _this.testWidth();
    };

    return _this;
  }

  (0, _createClass2.default)(UIHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "testWidth",
    value: function testWidth() {
      if (this._headerEl == null) {
        return;
      } // Measure width without the width-constrained class


      if (this.state.widthConstrained) {
        this._headerEl.classList.remove('private-header--width-constrained');
      }

      var titleEl = this._headerEl.querySelector('.private-header__title');

      if (titleEl == null) {
        return;
      }

      var widthConstrained = titleEl.clientWidth < CONSTRAINED_TITLE_WIDTH;

      if (this.state.widthConstrained) {
        this._headerEl.classList.add('private-header--width-constrained');
      }

      if (widthConstrained !== this.state.widthConstrained) {
        this.setState({
          widthConstrained: widthConstrained
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alert = _this$props.alert,
          badge = _this$props.badge,
          breadcrumbs = _this$props.breadcrumbs,
          children = _this$props.children,
          className = _this$props.className,
          details = _this$props.details,
          flush = _this$props.flush,
          fullWidth = _this$props.fullWidth,
          headingLevel = _this$props.headingLevel,
          role = _this$props.role,
          tabs = _this$props.tabs,
          title = _this$props.title,
          titleBadge = _this$props.titleBadge,
          titleControls = _this$props.titleControls,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["alert", "badge", "breadcrumbs", "children", "className", "details", "flush", "fullWidth", "headingLevel", "role", "tabs", "title", "titleBadge", "titleControls", "use"]);
      var widthConstrained = this.state.widthConstrained;
      var classes = (0, _classnames.default)('private-header', className, {
        'private-header--with-breadcrumbs': breadcrumbs,
        'private-header--condensed': use === 'condensed',
        'private-header--full-width': fullWidth,
        'private-header--flush': flush,
        'private-header--with-details': details,
        'private-header--with-tabs': tabs,
        'private-header--width-constrained': widthConstrained
      });

      if (titleBadge) {
        _devLogger.default.warn({
          message: 'UIHeader: the `titleBadge` prop is deprecated and may be ' + 'removed in the future. Please use the `titleControls` prop instead.',
          key: 'UIHeader: use titleControls prop'
        });
      }

      return _react.default.createElement("header", (0, _extends2.default)({
        className: classes,
        ref: this.headerRefCallback,
        role: "presentation"
      }, rest), breadcrumbs != null ? breadcrumbs : null, _react.default.createElement("div", {
        className: "private-header__inner",
        role: role
      }, title ? renderHeading(badge, children, headingLevel, title, titleBadge, titleControls) : null, renderToolbar(children)), details != null ? details : null, alert != null ? _react.default.createElement("div", {
        className: "private-header__alert"
      }, alert) : null, tabs != null ? tabs : null);
    }
  }]);
  return UIHeader;
}(_react.Component);

exports.default = UIHeader;
UIHeader.propTypes = {
  alert: _propTypes.default.node,
  breadcrumbs: _propTypes.default.node,
  badge: _propTypes.default.node,
  children: _propTypes.default.node,
  details: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired,
  fullWidth: _propTypes.default.bool.isRequired,
  headingLevel: _propTypes.default.oneOf(_HeadingConstants.HEADING_SIZES),
  tabs: _propTypes.default.node,
  title: _propTypes.default.node,
  titleBadge: _propTypes.default.node,
  titleControls: _propTypes.default.node,
  use: _propTypes.default.oneOf(['condensed'])
};
UIHeader.defaultProps = {
  flush: false,
  // for backwards compat, this will be true in next major version
  fullWidth: true,
  headingLevel: 'h1',
  role: 'banner'
};
UIHeader.displayName = 'UIHeader';
module.exports = exports.default;